<mat-expansion-panel class="mat-elevation-z0"
  (opened)="emitToggle()"
  (collapsed)="emitToggle()"
  >

  <mat-expansion-panel-header
    [expandedHeight]="'60px'"
    [collapsedHeight]="'60px'"
    >
    <mat-panel-title><h2>{{benefitCategory.categoryName}}</h2></mat-panel-title>
  </mat-expansion-panel-header>

  @for (benefitGroup of benefitCategory.benefitGroupData; track benefitGroup) {
    <app-benefit-group
      [benefitGroup]="benefitGroup"
      [categoryName]="benefitCategory.categoryName"
      [market]="market">
    </app-benefit-group>
  }

</mat-expansion-panel>



